import { useEffect } from 'react';

const PDF_HIGHLIGHT_STYLES = `
  /* Ensure PDF canvas (images) are visible */
  .react-pdf__Page__canvas {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    z-index: 1 !important;
    position: relative !important;
  }
  .react-pdf__Page {
    position: relative !important;
    /* Contain selection within page boundaries */
    contain: layout style;
  }
  .react-pdf__Page__textContent {
    user-select: text !important;
    pointer-events: auto !important;
    z-index: 10 !important;
    /* Improved text selection control */
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    /* Prevent selection from bleeding across page boundaries */
    isolation: isolate;
  }

  /* Citation highlight overlay (does not modify text spans) */
  .react-pdf__Page .pdf-highlight-overlay {
    position: absolute;
    inset: 0;
    z-index: 5;
    pointer-events: none;
  }
  .react-pdf__Page .pdf-highlight-overlay .pdf-highlight-rect {
    position: absolute;
    background-color: rgba(34, 197, 94, 0.4) !important;
    border-radius: 2px;
    pointer-events: none;
  }
  .react-pdf__Page__textContent span {
    user-select: text !important;
    pointer-events: auto !important;
    z-index: 10 !important;
    min-width: 1px !important;
    /* Improved selection behavior */
    cursor: text;
    /* Prevent overly aggressive selection */
    white-space: pre-wrap;
    /* Better word/line boundary detection */
    word-break: normal;
    overflow-wrap: normal;
  }
  .react-pdf__Page__textContent span[data-highlight-id] {
    background-color: rgba(34, 197, 94, 0.4) !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
    position: relative !important;
    z-index: 10 !important;
    display: inline !important;
    vertical-align: baseline !important;
    line-height: inherit !important;
    /* Ensure visibility */
    opacity: 1 !important;
    visibility: visible !important;
    /* Prevent text from being hidden */
    color: inherit !important;
    /* Ensure the highlight is above other elements */
    isolation: isolate !important;
  }
  /* NEW APPROACH: Multiline highlight parts */
  .react-pdf__Page__textContent span.multiline-highlight-part {
    background-color: rgba(34, 197, 94, 0.4) !important;
    display: inline !important;
    position: relative !important;
    z-index: 10 !important;
  }
  .react-pdf__Page__textContent span[data-highlight-id]:hover {
    background-color: rgba(255, 193, 7, 0.9) !important;
    box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.5);
  }
  .highlight-remove-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    background: rgba(220, 38, 38, 0.95);
    color: white;
    border: 2px solid white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    opacity: 0;
    transition: all 0.2s ease;
    z-index: 100;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    pointer-events: auto;
    line-height: 1;
  }
  .highlight-remove-btn:hover {
    background: rgba(220, 38, 38, 1);
    transform: scale(1.15);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.4);
  }
  .react-pdf__Page__textContent span[data-highlight-id]:hover .highlight-remove-btn {
    opacity: 1;
  }
  /* Highlight navigation animation - ONLY for highlight spans, NOT for notes */
  .react-pdf__Page__textContent span[data-highlight-id].highlight-navigating:not([data-note-id]):not([class*="note"]) {
    /* Performance optimizations: Use will-change and transform for GPU acceleration */
    will-change: transform, opacity, box-shadow;
    animation: pulse 0.8s ease-in-out infinite, ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
    /* Optimized box-shadow: Reduced layers for better performance */
    box-shadow: 0 0 15px rgba(255, 193, 7, 0.9), 0 0 30px rgba(255, 193, 7, 0.5) !important;
    outline: 3px solid rgba(255, 193, 7, 0.8) !important;
    outline-offset: 2px !important;
    border-radius: 3px !important;
    z-index: 20 !important;
    position: relative !important;
    background-color: rgba(255, 193, 7, 0.85) !important;
    /* Use transform for GPU acceleration instead of position changes */
    transform: translateZ(0);
    /* Optimize rendering */
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
  }

  /* Beautiful controlled text selection styling */
  .react-pdf__Page__textContent ::selection {
    background: rgba(59, 130, 246, 0.45) !important; /* Beautiful blue */
    color: inherit !important;
    text-shadow: none !important;
    /* Smooth selection rendering */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .react-pdf__Page__textContent ::-moz-selection {
    background: rgba(59, 130, 246, 0.45) !important;
    color: inherit !important;
    text-shadow: none !important;
  }
  .react-pdf__Page__textContent span::selection {
    background: rgba(59, 130, 246, 0.45) !important;
    color: inherit !important;
    text-shadow: none !important;
    /* Add subtle border for better definition */
    outline: 1px solid rgba(59, 130, 246, 0.2);
    outline-offset: -1px;
  }
  .react-pdf__Page__textContent span::-moz-selection {
    background: rgba(59, 130, 246, 0.45) !important;
    color: inherit !important;
    text-shadow: none !important;
  }
  
  /* Enhanced selection control - prevent text from bleeding across structural boundaries */
  .react-pdf__Page__textContent br,
  .react-pdf__Page__textContent br::selection,
  .react-pdf__Page__textContent br::-moz-selection {
    user-select: none !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
  }
  
  /* Improve selection precision for word boundaries */
  .react-pdf__Page__textContent span:not([data-highlight-id]) {
    /* Allow natural word selection */
    cursor: text;
    -webkit-tap-highlight-color: transparent;
  }
  /* Ensure notes are NOT affected by highlight animation */
  .react-pdf__Page__textContent [data-note-id] .highlight-navigating,
  .react-pdf__Page__textContent [class*="note"] .highlight-navigating {
    animation: none !important;
    box-shadow: none !important;
    outline: none !important;
  }
`;

export default function usePdfHighlightStyles() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = PDF_HIGHLIGHT_STYLES;
    document.head.appendChild(style);

    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);
}
